import styled from "styled-components";
import { Link } from 'react-router-dom';
import { LABEL, transition, mediaQuery, UI_TAG, colors2, ButtonGhostV2} from "oolib";
import { hamburgerMenu_backdrop_ZINDEX, HamburgerMenu_ZINDEX } from "@/CONSTANTS";

export const StyledHamburgerBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(169, 169, 169, 0.61);;
  backdrop-filter: blur(8.5px);
  z-index: ${hamburgerMenu_backdrop_ZINDEX};
  opacity: ${({opened})=> opened? '1': '0'};
  visibility: ${({opened})=> opened? 'visible': 'hidden'};
  ${transition('opacity, visibility')};

  ${mediaQuery('lg')}{
    display: none;
  }
`;

export const StyledCloseButton = styled(ButtonGhostV2)`
  position: fixed;
  top: 2rem;
  z-index: ${HamburgerMenu_ZINDEX};
  border-radius: "50%";
  background: ${colors2.grey5};
  color: ${colors2.white};
  border-radius: 50%;
  padding: 1.2rem;
`;

export const StyledHumburgerMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${colors2.white};
  width: 80%;
  height: 100%;
  overflow-y: auto;
  z-index: ${HamburgerMenu_ZINDEX};
  padding: 1rem;
  padding-bottom: 2rem;
  border-radius: 0 2rem 2rem 0;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.10);
  transform: translateX(${({opened})=> opened? '0': '-100%'});

  ${transition('transform')};


  ${mediaQuery('lg')}{
    display: none;
  }
  
`;

export const StyledMenuHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  height: 6rem;
  background-color: ${colors2.white};
  box-shadow: 0px 4px 5px rgba(235, 235, 235, 0.4);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;

  margin: 0 -1rem;
  ${mediaQuery('sm')}{
    margin: 0 -1rem;
    padding: 0 1rem;
  }
`;

export const StyledMenuSection = styled.div`//
  padding: 1.2rem 1.5rem;
  margin-bottom: 1.2rem;
  border-bottom: 1px solid ${colors2.grey10};
`;

export const StyledMenuSectionLabel = styled(UI_TAG)`
  color: ${colors2.grey50};
  padding-bottom: 0.7rem;
`;

export const StyledLinksWrapper = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: 0 -2.5rem;
  /* ${mediaQuery('sm')}{margin: 0 -2.5rem;} */
`;

export const StyledMenuLink = styled(Link)`
  color: ${colors2.grey80};
  display: inline-block;
  padding: 1rem 2.5rem;
  width: 100%;
  background-color: ${({active, theme})=> active? theme.colors.primaryColor10: colors2.white};
  
  /* ${mediaQuery('sm')}{padding: 1rem 2.5rem;} */
  /* ${transition('background-color')} */
  &:hover {background-color: ${({theme}) => theme.colors.primaryColor10}}
`;